var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "146px",
    viewBox: "0 0 256 146",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Baseline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#99DBB1",
    points: "182.918378 35.0449089 220.954789 73.0813201 183.345088 110.691626 159.83978 87.1857136 142.316872 104.707413 165.823389 128.213325 183.345088 145.736232 256 73.0813201 238.477092 55.5596211 200.440681 17.5226056"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99DBB3",
    points: "72.6546102 3.43564427e-14 17.0952913 55.5593189 34.6175947 73.0816223 72.6546102 35.0446067 96.1605224 58.5505189 113.682826 41.02882 90.1769136 17.5229078"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#008F32",
    points: "73.0816223 110.691324 17.5229078 55.1320046 3.43564427e-14 72.654308 73.0816223 145.73593 90.1766114 128.640941 90.6045301 128.213627 200.867935 17.9496177 183.345632 0.427314287"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogo);
export default __webpack_public_path__ + "static/media/blogo.555ea600a668e33d68b05753a88dd777.svg";
export { ForwardRef as ReactComponent };